import JobScoreFit from "./JobScoreFit";

export default JobScoreFit;
